import React from "react";
import signImg from "../../../../static/images/sign.svg";
import infoIcon from "../../../../static/images/info.svg";
import Tooltip from "../../../secondary/Tooltip/tooltip";
import styles from "./signAndLock.module.scss";

export const PendingTooltip = ({ pendingItems }) => (
  <div className={styles.pendingTooltip}>
    <div className={styles.pendingTitle}>You must complete the following:</div>
    {Object.entries(
      pendingItems.reduce((groups, item) => {
        if (!groups[item.section]) groups[item.section] = [];
        groups[item.section].push(item.label);
        return groups;
      }, {})
    ).map(([section, items]) => (
      <div key={section} className={styles.pendingRow}>
        <span className={styles.pendingSection}>{section}:</span> <span>{items.join(", ")}</span>
      </div>
    ))}
  </div>
);

export const SignButton = ({ isSign, pendingItems, disabled, onSign }) => (
  <button className={styles.lock} data-testid="sign" onClick={onSign} disabled={disabled}>
    <img src={signImg} alt="sign" />
    Sign
    {/* {!isSign && (
      <Tooltip placement="right" className={styles.tooltip} content={<PendingTooltip pendingItems={pendingItems} />} width="600px">
        <img src={infoIcon} alt="info" />
      </Tooltip>
    )} */}
  </button>
);
